<template>
  <div class="logo">
    <template v-if="logo === 'Partou'">
      <kids-foundation-logo
        class="logo-icon"
        :class="setStickyStyling ? 'logo-sticky': ''"
      />
    </template>
    <template v-if="logo === 'Partougroup'">
      <kids-foundation-logo-secondary
        class="logo-icon"
        :class="setStickyStyling ? 'logo-sticky': ''"
      />
    </template>
    <template v-if="logo === 'PartougroupWhite'">
      <kids-foundation-logo-white
        class="logo-icon"
        :class="setStickyStyling ? 'logo-sticky': ''"
      />
    </template>
    <template v-else-if="logo === 'Smallsteps'">
      <small-steps-logo
        icon="smallsteps-partou-logo"
        class="logo-icon logo-icon--double"
      />
    </template>
  </div>
</template>

<script>

export default {
  name: 'KfLogo',
  components: {
    KidsFoundationLogo: () => import(/* webpackChunkName: "main"*/ '@/components/svg/KidsfoundationLogoColor.vue'),
    KidsFoundationLogoSecondary: () => import(/* webpackChunkName: "main"*/ '@/components/svg/KidsfoundationLogoColorSecondary.vue'),
    KidsFoundationLogoWhite: () => import(/* webpackChunkName: "main"*/ '@/components/svg/KidsfoundationLogoWhite.vue'),
    SmallStepsLogo: () => import(/* webpackChunkName: "main"*/ '@/components/svg/SmallStepsPartou.vue'),
  },
  props: {
    logo: {
      type: String,
      default: '',
    },
    setStickyStyling: {
      type: Boolean,
      default: false,
    }
  },
};
</script>

<style lang="postcss">
.logo {
  @apply block;
  transform: translate(0, 0);
  display: flex;
 justify-content: flex-start;

  @screen lg {
    &-sticky {
      transform: scale(0.7) translate(0,0);
      margin-top: -30px;
    }

  }
  @screen sm {
    justify-content: center;
    }
  .logo-icon {
    transition: transform .3s ease, margin .3s ease;
    width: 64px;
    height: 64px;


    @screen lg {

      width: 114px;
       height: 114px;

    }

    &--double {
      width: 120px;
      transform: translate(0px, -10px);

      @screen md {
        width: 300px;
        transform: translate(0, 0);
      }
    }
  }
}
</style>
